import styled from 'styled-components';

import { colorScheme } from '../../theme';

export const Table = styled.table<{ dividers?: boolean }>`
  background-color: ${colorScheme.card.background};
  padding: 16px 32px;
  border-radius: 16px;

  width: 100%;
  th {
    @include typography.text--medium;
    padding: 16px 0;
  }
  td {
    @include typography.text--regular;
    padding: 8px 0;
  }

  ${({ dividers }) =>
    dividers &&
    `
      td {
        padding: 16px 0;
      }

      tbody {
        tr {
          border-bottom: solid 1px ${colorScheme.divider};
        }
        tr:last-of-type {
          border-bottom: none;
        }
      }
    `}
`;
